<template>
  <div class="container md:mt-24 mt-16">
    <!-- <div class="grid grid-cols-1 pb-8 text-center">
      <h3 class="mb-4 md:text-3xl md:leading-normal text-2xl leading-normal font-semibold">Ce que disent nos clients
      </h3>

      
    </div> -->
    
    <!--end grid-->

    <div class="grid grid-cols-1 my-8">
      <!-- <div class="slider">
        <testimonial-item-component />
        <testimonial-item-component />
        <testimonial-item-component />
        <testimonial-item-component />
        <testimonial-item-component />
        <testimonial-item-component />
      </div> -->

      <!-- <div class="tiny-three-item">
        <div class="tiny-slide text-center">
          <div class="customer-testi">
            <div class="content relative rounded shadow dark:shadow-gray-800 m-2 p-6 bg-white dark:bg-slate-900">
              <i class="mdi mdi-format-quote-open mdi-48px text-indigo-600"></i>
              <p class="text-slate-400">" It seems that only fragments of the original text remain in the Lorem Ipsum
                texts used today. "</p>
              <ul class="list-none mb-0 text-amber-400 mt-3">
                <li class="inline"><i class="uil uil-star"></i></li>
                <li class="inline"><i class="uil uil-star"></i></li>
                <li class="inline"><i class="uil uil-star"></i></li>
                <li class="inline"><i class="uil uil-star"></i></li>
                <li class="inline"><i class="uil uil-star"></i></li>
              </ul>
            </div>

            <div class="text-center mt-5">
              <img src="../assets/images/client/01.jpg" class="h-14 w-14 rounded-full shadow-md mx-auto" alt="">
              <h6 class="mt-2 font-semibold">Calvin Carlo</h6>
              <span class="text-slate-400 text-sm">Manager</span>
            </div>
          </div>
        </div>

        <div class="tiny-slide text-center">
          <div class="customer-testi">
            <div class="content relative rounded shadow dark:shadow-gray-800 m-2 p-6 bg-white dark:bg-slate-900">
              <i class="mdi mdi-format-quote-open mdi-48px text-indigo-600"></i>
              <p class="text-slate-400">" The most well-known dummy text is the 'Lorem Ipsum', which is said to have
                originated in the 16th century. "</p>
              <ul class="list-none mb-0 text-amber-400 mt-3">
                <li class="inline"><i class="mdi mdi-star"></i></li>
                <li class="inline"><i class="mdi mdi-star"></i></li>
                <li class="inline"><i class="mdi mdi-star"></i></li>
                <li class="inline"><i class="mdi mdi-star"></i></li>
                <li class="inline"><i class="mdi mdi-star"></i></li>
              </ul>
            </div>

            <div class="text-center mt-5">
              <img src="../assets/images/client/02.jpg" class="h-14 w-14 rounded-full shadow-md mx-auto" alt="">
              <h6 class="mt-2 font-semibold">Christa Smith</h6>
              <span class="text-slate-400 text-sm">Manager</span>
            </div>
          </div>
        </div>

        <div class="tiny-slide text-center">
          <div class="customer-testi">
            <div class="content relative rounded shadow dark:shadow-gray-800 m-2 p-6 bg-white dark:bg-slate-900">
              <i class="mdi mdi-format-quote-open mdi-48px text-indigo-600"></i>
              <p class="text-slate-400">" One disadvantage of Lorum Ipsum is that in Latin certain letters appear more
                frequently than others. "</p>
              <ul class="list-none mb-0 text-amber-400 mt-3">
                <li class="inline"><i class="uil uil-star"></i></li>
                <li class="inline"><i class="uil uil-star"></i></li>
                <li class="inline"><i class="uil uil-star"></i></li>
                <li class="inline"><i class="uil uil-star"></i></li>
                <li class="inline"><i class="uil uil-star"></i></li>
              </ul>
            </div>

            <div class="text-center mt-5">
              <img src="../assets/images/client/03.jpg" class="h-14 w-14 rounded-full shadow-md mx-auto" alt="">
              <h6 class="mt-2 font-semibold">Jemina CLone</h6>
              <span class="text-slate-400 text-sm">Manager</span>
            </div>
          </div>
        </div>

        <div class="tiny-slide text-center">
          <div class="customer-testi">
            <div class="content relative rounded shadow dark:shadow-gray-800 m-2 p-6 bg-white dark:bg-slate-900">
              <i class="mdi mdi-format-quote-open mdi-48px text-indigo-600"></i>
              <p class="text-slate-400">" Thus, Lorem Ipsum has only limited suitability as a visual filler for German
                texts. "</p>
              <ul class="list-none mb-0 text-amber-400 mt-3">
                <li class="inline"><i class="uil uil-star"></i></li>
                <li class="inline"><i class="uil uil-star"></i></li>
                <li class="inline"><i class="uil uil-star"></i></li>
                <li class="inline"><i class="uil uil-star"></i></li>
                <li class="inline"><i class="uil uil-star"></i></li>
              </ul>
            </div>

            <div class="text-center mt-5">
              <img src="../assets/images/client/04.jpg" class="h-14 w-14 rounded-full shadow-md mx-auto" alt="">
              <h6 class="mt-2 font-semibold">Smith Vodka</h6>
              <span class="text-slate-400 text-sm">Manager</span>
            </div>
          </div>
        </div>

        <div class="tiny-slide text-center">
          <div class="customer-testi">
            <div class="content relative rounded shadow dark:shadow-gray-800 m-2 p-6 bg-white dark:bg-slate-900">
              <i class="uil uil-folder-question text-indigo-600"></i>
              <p class="text-slate-400">" There is now an abundance of readable dummy texts. These are usually used when a
                text is required. "</p>
              <ul class="list-none mb-0 text-amber-400 mt-3">
                <li class="inline"><i class="uil uil-star"></i></li>
                <li class="inline"><i class="uil uil-star"></i></li>
                <li class="inline"><i class="uil uil-star"></i></li>
                <li class="inline"><i class="uil uil-star"></i></li>
                <li class="inline"><i class="uil uil-star"></i></li>
              </ul>
            </div>

            <div class="text-center mt-5">
              <img src="../assets/images/client/05.jpg" class="h-14 w-14 rounded-full shadow-md mx-auto" alt="">
              <h6 class="mt-2 font-semibold">Cristino Murfi</h6>
              <span class="text-slate-400 text-sm">Manager</span>
            </div>
          </div>
        </div>

        <div class="tiny-slide text-center">
          <div class="customer-testi">
            <div class="content relative rounded shadow dark:shadow-gray-800 m-2 p-6 bg-white dark:bg-slate-900">
              <i class="mdi mdi-format-quote-open mdi-48px text-indigo-600"></i>
              <p class="text-slate-400">" According to most sources, Lorum Ipsum can be traced back to a text composed by
                Cicero. "</p>
              <ul class="list-none mb-0 text-amber-400 mt-3">
                <li class="inline"><i class="uil uil-star"></i></li>
                <li class="inline"><i class="uil uil-star"></i></li>
                <li class="inline"><i class="uil uil-star"></i></li>
                <li class="inline"><i class="uil uil-star"></i></li>
                <li class="inline"><i class="uil uil-star"></i></li>
              </ul>
            </div>

            <div class="text-center mt-5">
              <img src="../assets/images/client/06.jpg" class="h-14 w-14 rounded-full shadow-md mx-auto" alt="">
              <h6 class="mt-2 font-semibold">Cristino Murfi</h6>
              <span class="text-slate-400 text-sm">Manager</span>
            </div>
          </div>
        </div>
      </div> -->
    </div>
    
    <!--end grid-->
  </div>
</template>

<script>
// yourScript.js
import { tns } from "tiny-slider";
import 'tiny-slider/dist/tiny-slider.css'
import TestimonialItemComponent from './TestimonialItemComponent.vue';

export default {
  components: { TestimonialItemComponent },
  mounted() {
    const slider = tns({
      container: '.slider',
      items: 3,
      // mode: "carousel",
      loop: true,
      slideBy: 'page',
      autoplay: true,
      controls: false,
      nav: true,
      speed: 400,
      swipeAngle: false,
      autoplayButtonOutput: false,
      autoplayTimeout: 3000,
      navPosition: "bottom",
      gutter: 12,
      responsive: {
        992: {
          items: 3
        },

        767: {
          items: 2
        },

        320: {
          items: 1
        },
      }
    });
  },
}
</script>

<style lang="css">
.slider-item {
  background: grey;
  border-right: 2px solid #333;
  padding: 1.5rem 0.75rem;
  position: relative;
}

.slider-item:before {
  content: ".slider-item";
  position: absolute;
  left: 0;
  top: 0;
  color: #0E3460;
}

.slider-item:hover {
  cursor: pointer;
}
</style>